module.exports = __webpack_public_path__ + "img/equinsa.3935894d.png";